import {useHistory, useParams} from 'react-router-dom';
import styled from "styled-components";
import React, {useEffect, useState} from "react";
import Main from '../../../components/main';
import CommunityHeader from "../../../components/community_header";
import {useBottomBar} from "../../../app_context";
import {useBaseCommunity, useLoggedIn, useStoreProfile} from '../../../store';
import {formatDate} from "../../../utils/calendar";
import {useCommunityReportReasons} from "../../../api/report_reasons";
import useFeedback from "../../../utils/use_feedback";
import {useCommunities, useModeratorList} from "../../../api/communities";
import useModal from "../../../modals";
import Sheet from "../../../components/bottom-sheet/sheet";
import SignupPromptSheet from "../../../components/bottom-sheet/signup_prompt";
import {useSheetModal} from "../../../components/test/ModalContext";
import {themecolors} from "../../../utils/themecolors";
import {FadedTopBar} from "../../../components/top_bar";

const About = styled.div``;
const Topics = styled.div``;
const Heading = styled.div``;
const Message = styled.div``;

const Rule = styled.div``;
const RuleList = styled(({rules, className}) => {
    return (
        <div className={className}>
            <ul>
                {rules?.map((rule, i) =>
                    // eslint-disable-next-line react/no-array-index-key
                    <li key={i}>
                        {rule}
                    </li>
                )}
            </ul>
        </div>
    );
})`
  ${Rule} {
    display: flex;
  }
  font-size: 14px;
  ul {
    list-style-type: upper-roman;
  }
  li {
    padding: 2px 0;
  }
`;


const RulesCommunity = styled(({className}) => {

    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    const {feedbackCh} = useFeedback();
    const communityInfo = useCommunities(feedbackCh, [paramsCommunity])[0] || false;
    const created = formatDate(communityInfo.created ? communityInfo.created : 0);
    const rules = useCommunityReportReasons(feedbackCh, community)?.rules;
    const moderators = useModeratorList(feedbackCh, community);
    useBottomBar();

    const loggedIn = useLoggedIn();
    const history = useHistory();
    const modal = useModal();

    const {moderates} = useStoreProfile();

    const { openModal } = useSheetModal();

    const handleMessage = () => {

        if (loggedIn) {
            history.push(`/send?to=c:${communityInfo.name}`);
        } else {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        }

    };

    const [offset, setOffset] = useState(0);
    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        //window.history.scrollRestoration = 'manual';
    }, []);

    return (
        <>
            <FadedTopBar active={offset > 44} search community={community} sidebar={false} settings
                         style={{position: 'fixed'}} feedTitle={community.display_name || community} back
                         modTools={moderates.includes(community.name)}/>
            <div style={{paddingTop: '50px'}} />
             <CommunityHeader community={communityInfo} pageType={'Rules'}/>
            <Main>
                <About className={className}>
                    <Heading>Community Rules</Heading>
                    {rules && (
                        <RuleList rules={rules} />
                    )}
                </About>
            </Main>
        </>
    );
})`
  background-color: ${({theme}) => theme.color.name === 'dark' ? 'none' : theme.white_0};
  padding: 0 20px;
  padding-bottom: 16px;

  ${Heading} {
    display: flex;
    align-items: center;
    padding-top: 16px;
    padding-bottom: 12px;
    font-size: 15px;
    font-weight: 600;
  }

  ${Heading} ${Message} {
    margin-left: auto;
    cursor: pointer;
  }
  
  p {
    font-size: 14px;
  }

  svg {
    margin-right: 4px;
  }

  ${Topics} > * {
    margin-right: 4px;
    margin-bottom: 4px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : 'rgba(0, 0, 0, .05)'};
  }

  ${Topics} {
    margin: 12px 0;
  }`;

export default RulesCommunity;
